module.exports = __webpack_public_path__ + "static/3_EC-29f28370e79d828a8a7d251d7c7eb7b9.svg";